import React from 'react';
import { METRIKA_GOALS, reachGoal } from '../analytics';

const directions = [
  {
    index: '01',
    label: 'Групповая программа',
    title: 'Развитие управленческого мышления',
    description:
      'Открытые лекции и основная программа развития руководителей, которым нужен более точный язык управления и изменений.',
    action: 'Перейти в школу',
    href: 'https://school.glotov.pro',
    external: true,
    goal: METRIKA_GOALS.SELECT_SCHOOL,
  },
  {
    index: '02',
    label: 'Один на один',
    title: 'Персональное развитие руководителя',
    description:
      'Индивидуальная программа под управленческую ситуацию, профессиональные задачи и личную траекторию развития лидера.',
    action: 'Узнать о первой встрече',
    href: 'https://school.glotov.pro/meta-vstrecha',
    external: true,
    goal: METRIKA_GOALS.SELECT_PERSONAL,
  },
  {
    index: '03',
    label: 'Корпоративный контур',
    title: 'ИИ для компании',
    description:
      'Аудит, план внедрения и совместная реализация MVP для среднего и крупного бизнеса — от задачи до работающего решения.',
    action: 'Как внедряем ИИ',
    href: '/ai/',
    goal: METRIKA_GOALS.SELECT_AI,
  },
];

function Directions() {
  return (
    <section id="directions" className="section directions-section">
      <div className="directions-intro">
        <div className="section-heading">
          <p className="eyebrow">С чего начать</p>
          <h2>Выберите задачу и формат работы</h2>
        </div>
        <p>
          Три самостоятельных направления: развитие управленческого мышления,
          персональное развитие руководителя и внедрение ИИ в компании.
        </p>
      </div>

      <div className="directions-grid">
        {directions.map((direction) => (
          <article className="direction-card" key={direction.index}>
            <div className="direction-meta">
              <span>{direction.index}</span>
              <span>{direction.label}</span>
            </div>
            <h3>{direction.title}</h3>
            <p>{direction.description}</p>
            <a
              className="direction-action"
              href={direction.href}
              target={direction.external ? '_blank' : undefined}
              rel={direction.external ? 'noopener noreferrer' : undefined}
              data-metrika-goal={direction.goal}
              onClick={() => reachGoal(direction.goal)}
            >
              {direction.action}
              <span aria-hidden="true">{direction.external ? '↗' : '→'}</span>
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Directions;
